const touchable = ('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)

const userAgent = navigator.userAgent.toLowerCase()

const isApple = userAgent.includes('mac os x')
const isAndroid = userAgent.includes('android')
const isIPad = userAgent.includes('ipad')
const isIPhone = userAgent.includes('iphone')

export const useDeviceDetect = () => {
  return {
    touchable,
    isApple,
    isAndroid,
    isIPad,
    isIPhone,
  }
}
